<main>

  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Pedidos de Contacto</h3>
    <p class="text-sm">Dar tratamento aos pedidos de visualização de contatos.</p>
  </div>

  <!-- content wrapper -->
  <div class="bg-white p-5 border border-round">

    <!-- filtros aqui -->
    <div class="my-5">
      <app-event-admin-filter [hideTitle]="true" [hideEventStatus]="true" [hideProvince]="true"
      (submitFilter)="onFilterSubmit($event)"></app-event-admin-filter>
    </div>

    <div>
      <p-table [value]="contactRequests" styleClass="text-xs" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Solicitante</th>
            <th>Ocorrência</th>
            <th>Pedido</th>
            <th>Data de Ocorrência</th>
            <th>Açcões</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contactRequest>

          <tr>
            <td>{{ contactRequest.accountName }}</td>
            <td>{{ contactRequest.eventName | titlecase }}</td>
            <td>{{ contactRequest.message }}</td>
            <td>{{ contactRequest.creationDate | date:'yyyy-MM-dd' }}</td>
            <td class="space-x-4">
              <i (click)="answerContactRequestAlert(contactRequest.id,true)" [pTooltip]="'Aceitar'"
                tooltipPosition="top"
                [tooltipStyleClass]="'text-xs'"
              class="btn hover:text-green-600 pi pi-thumbs-up cursor-pointer"></i>
              <i (click)="answerContactRequestAlert(contactRequest.id,false)" [pTooltip]="'Rejeitar'"
                tooltipPosition="top"
                [tooltipStyleClass]="'text-xs'"
              class="btn hover:text-red-600 pi pi-thumbs-down cursor-pointer"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>

      @if (!tableHasdata) {
        <p class="flex justify-center text-sm text-gray-500 font-medium my-10">Nenhuma ocorrência
          foi
        encontrada, por favor verifique os filtros</p>
      }
    </div>

    @if (pagination) {
      <app-paginator [paginationDetails]="pagination"
        (pageChangeEvent)="onPageChange($event)"
      ></app-paginator>
    }
  </div>

</main>
